module.exports = __webpack_public_path__ + "static/media/full-screen.ecd0cb64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/full-screen.svg
// module id = 1161
// module chunks = 0